module.exports = __webpack_public_path__ + "img/gb9116_16_c.prt.2bd62ce9.jpg";